// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[class*=\" el-icon-lx\"],[class^=el-icon-lx]{font-family:lx-iconfont!important}", ""]);
// Exports
module.exports = exports;
